<template>
  <Modal :value="value"
         @on-cancel="closeModal"
         @on-ok="submitData"
         v-bind="$attrs"
         :loading="isLoading">
    <div class="captcha-form">
      <Form ref="form"
            :model="formData"
            :rules="formRules">
        <FormItem prop="captcha"
                  class="form-item-expand pic-expand">
          <Input placeholder="请输入图形验证码内容"
                 v-model="formData.captcha"
                 @on-enter="submitData">
          <a-icon type="safety-certificate"
                  slot="prepend" />
          </Input>

          <img class="item-expand"
               :src="captchaUrl"
               alt=""
               @click="initPage">
        </FormItem>

        <!-- 此处的 input 并没有实际作用，只是占位。 -->
        <!-- 因为 iview组件如果form表单里面只有一个输入框，会自动触发页面submit，而且拦截不住 -->
        <FormItem style="display:none;">
          <Input type="password"></Input>
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>

<script>
import AIcon from './a-icon'
import { API, request } from "../api/common";
const phoneRule = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
export default {
  components: { AIcon },
  name: 'captcha-modal',
  data () {
    return {
      formData: {
        captcha: '',
        captcha_key: '',
        mobile: ''
      },
      formRules: {
        captcha: [{ required: true, message: "请输入图形验证码内容", trigger: "blur" }, { min: 5, required: true, message: "请输入5个字符的图形验证码", trigger: "blur" }]
      },
      captchaUrl: '',
      isLoading: true // 这默认值需要为true，不loading的时候赋值为false，然后在改回true
    }
  },
  props: {
    value: {
      default: false,
      type: Boolean
    },
    mobile: {
      default: '',
      type: String
    }
  },
  model: {
    prop: 'value',
    event: 'toggleShow'
  },
  watch: {
    value: {
      handler (show) {
        if (show) {
          this.initPage()
        }
      },
      immediate: true
    }
  },
  methods: {
    initPage () {
      if (!this.mobile) {
        this.$emit('toggleShow')
        this.$Message.warning('请先输入手机号');
        return false
      }

      if (!phoneRule.test(this.mobile)) {
        this.$emit('toggleShow')
        this.$Message.warning('请输入正确的手机号');
        return false
      }

      this.isLoading = true
      this.formData = { captcha: '', captcha_key: '', mobile: this.mobile }

      request({
        url: API.captcha_mobile_api,
        params: {
          mobile: this.mobile
        }
      }).then(res => {
        if (res.data.step_code == 0) {
          // 发送成功
          this.$emit('send-success', {})
        } else if (res.data.step_code == 1) {
          this.formData.captcha_key = res.data.captcha.key
          this.captchaUrl = res.data.captcha.img
        } else {
          this.$emit('toggleShow')
          this.$Message.warning(res.msg);
        }
      })


    },
    closeModal (e) {
      // 关闭自己弹窗
      this.$emit('toggleShow', false)
    },
    submitData () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          request({
            url: API.captcha_mobile_api,
            params: this.formData
          }).then(res => {
            //  0-短信发送成功
            if (res.data.step_code == 0) {
              // 发送成功
              this.$emit('send-success', {})
              this.closeModal()
            } else {
              this.$Message.warning(res.msg);
            }
          }).catch(res => {
            // 重新加载图形码
            this.initPage()
          }).finally(res => {
            this.isLoading = false
            this.$nextTick(() => {
              this.isLoading = true
            })
          })
        } else {
          this.isLoading = false
          this.$nextTick(() => {
            this.isLoading = true
          })
        }
      })
      // this.$emit('toggleShow', false)
    }
  }
}
</script>

<style lang="less">
.captcha-form {
  padding: 40px 24px;
  padding-bottom: 0;

  .ivu-input {
    height: 40px;
    background: rgba(0, 0, 0, 0.04);
    border: none;
    &:focus {
      box-shadow: none;
    }
  }
  .ivu-input-group-prepend {
    background: rgba(0, 0, 0, 0.04);
    border: none;
    width: 40px;
  }

  .form-item-expand {
    position: relative;
    .item-expand {
      position: absolute;
      top: 0;
      right: 0;
      height: 40px;
      line-height: 40px;
      display: block;
      z-index: 100;
    }
    &.sms-expand {
      .item-expand {
        width: 96px;
        color: #3771e5;
        padding: 0 13px;
        text-align: right;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;

        &[disabled] {
          cursor: not-allowed;
          color: #c5c8ce;
        }
      }
      .ivu-input {
        padding-right: 96px;
      }
    }

    &.pic-expand {
      .ivu-form-item-content {
        display: flex;
        flex-wrap: nowrap;
      }
      .ivu-input-group {
        flex: 1;
        width: 70%;
      }
      .item-expand {
        margin-left: 16px;
        position: static;
        color: #3771e5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// captcha-modal.vue?c8f80eea